<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<button
					type="button"
					class="btn-close"
					(click)="filtersClose()"
					data-bs-dismiss="modal"
					aria-label="Close"
				></button>
			</div>
			<div class="modal-body">
				<div class="container">
					<div class="mb-3">
						<ng-select
							id="documentKinds"
							name="documentKinds"
							[(ngModel)]="filters.kind"
							[multiple]="true"
							placeholder="Rodzaj dokumentu"
							><ng-option [value]="item.id" *ngFor="let item of documentKinds"
								>{{ item.kind }}
							</ng-option></ng-select
						>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="btn-group me-auto">
					<button mat-raised-button color="basic" type="button" class="me-2" (click)="filtersClear()">
						Wyczyść
					</button>
					<button mat-raised-button color="accent" type="button" (click)="filtersDefault()">Domyślne</button>
				</div>
				<div class="btn-group">
					<button mat-raised-button color="primary" type="button" class="me-2" (click)="filtersSave()">
						Pokaż
					</button>
					<button
						mat-raised-button
						color="warn"
						type="button"
						(click)="filtersClose()"
						data-bs-dismiss="modal"
					>
						Anuluj
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
